import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=40a646d8&scoped=true"
import script from "./Image.js?vue&type=script&lang=js&external"
export * from "./Image.js?vue&type=script&lang=js&external"
import style0 from "./Image.scss?vue&type=style&index=0&id=40a646d8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a646d8",
  null
  
)

export default component.exports